<div class="phone-input-wrapper" [class.phone-input-disabled]="disabled">
    <div class="phone-input-country">
      <mat-select
        [value]="selectedCountry"
        [disabled]="disabled"
        [compareWith]="compareCountries"
        (selectionChange)="onCountryChange($event.value)"
        class="phone-input-select"
      >
        <mat-select-trigger>
          <span class="phone-input-flag" *ngIf="selectedCountry">{{ selectedCountry.flag }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let country of countries" [value]="country">
          <span class="phone-option">{{ country.flag }} +{{ country.dialCode }} {{ country.iso2 | countryName }}</span>
        </mat-option>
      </mat-select>
    </div>
    <input
      class="phone-input-national"
      type="tel"
      inputmode="tel"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="nationalNumber"
      (input)="onNationalInput($event)"
      (blur)="onBlur()"
      (click)="$event.stopPropagation()"
      (focus)="$event.stopPropagation()"
    />
  </div>
  <div
    class="mat-error mat-form-field-subscript-wrapper phone-input-error"
    *ngIf="ngControl?.control?.invalid && ngControl?.control?.touched && ngControl?.control?.errors?.e164"
  >
    <span class="text-danger font-14">{{ errorMessage }}</span>
  </div>